module.exports = __webpack_public_path__ + "img/nt108-01-81-1.prt.ef47fb90.jpg";